import { createRoot, type Root } from "react-dom/client";
import ExecutiveProfile from "../pages/ExecutiveProfile/ExecutiveProfile";
import "../index.css";
import "../pages/ExecutiveProfile/ExecutiveProfile.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;
  root = createRoot(element);
  root.render(<ExecutiveProfile />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADExecutiveProfile = { mount, unmount };

function boot() {
  const element = document.getElementById("executive-profile-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
